<section class="login-section">

  <div class="container">
    <div class="product-container">
      <div class="product-inner">

        <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
          <span class="alreadyRegError" ng-bind-html="alreadyRegError"></span>
          <div class="reg1" *ngIf="!showAddFamily">
            <center class="top-gap-md">
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/sign-up-insurance.jpg"
                class="img-responsive">
            </center>
            <center class="logo-gap">
              <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg">
            </center>
            <h2 class="heading-signup">Sign Up</h2>
            <div class="" style="display: flex; justify-content: space-between;">
              <span style="color: red;">*</span><input type="text" style="width:99%" class="form-control" name="name" id="name" placeholder="Full Name" #name="ngModel"
                [(ngModel)]="data.name" pattern="[a-zA-Z\s]+" maxlength="200" required>
            </div>
            <div class="" style="display: flex; justify-content: space-between;">
              <span style="color: red;">*</span><input type="text" style="width:99%" class="form-control" name="email" id="email" placeholder="Email" #email="ngModel"
                [(ngModel)]="data.email" [email]="true" maxlength="100" required>
            </div>
            <div class="mb-3" style="display: flex; justify-content: space-between;">
              <span>&nbsp;</span><input type="text" #mobile="ngModel" style="width:99%" class="form-control" name="mobile" id="mobile" class="form-control"
                placeholder="Mobile No." (keydown.space)="$event.preventDefault();" minlength="10" maxlength="10"
                [(ngModel)]="data.mobile" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" >
            </div>
            <div class="form-group" *ngIf="!mobile.invalid">
              <span [innerHtml]="error" class="error"></span>
            </div>
            <div class="form-group">
              <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                <div *ngIf="mobile.errors.required">
                  Mobile number is required.
                </div>
                <div *ngIf="mobile.errors.minlength && !mobile.errors.pattern">
                  Mobile number must be at least 10 digits long.
                </div>
                <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                  Invalid mobile number.
                </div>
              </div>
              <div *ngIf="name.invalid && name.touched " class="error-message">
                <div *ngIf="name.errors.required">
                  Name is required.
                </div>
                <div *ngIf="name.errors.pattern">
                  Please enter the valid Name.
                </div>
              </div>
              <div *ngIf="email.invalid && email.touched " class="error-message">
                <div *ngIf="email.errors.required">
                  Email address is required.
                </div>
                <div *ngIf="email.errors.email">
                  Email must be a valid email address
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col top-gap-md" id="sendOTPButton">
                <button class="btn btn-submit btn-primary" type="submit" [disabled]="f.form.invalid"
                  (click)="onSubmit()">Send OTP</button>
              </div>
            </div>
          </div>
          <div class="reg2" *ngIf="showAddFamily">
            <!-- Add Family -->
            <h2>Add Family</h2>
            <div class="form-group">
              <select class="form-control" name="relation" id="relation" [(ngModel)]="familyMemberRelation">
                <option value="undefined" selected disabled>Relation</option>
                <option>Father</option>
                <option>Mother</option>
                <option>Husband</option>
                <option>Wife</option>
                <option>Son</option>
                <option>Daughter</option>
              </select>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" name="name" id="name" placeholder="Name"
                [(ngModel)]="familyMemberName">
            </div>

            <div class="form-group">
              <input type="date" class="form-control dateclass placeholderclass" name="dob" id="dob"
                placeholder="Date of Birth" [(ngModel)]="familyMemberDob">
            </div>

            <div class="row top-gap-lg">
              <div class="col">
                <button class="btn btn-submit btn-primary" (click)="backToReg()">Back</button>
              </div>
              <div class="col">
                <button class="btn btn-submit btn-primary" type="submit" [disabled]="f.form.invalid"
                  (click)="onSubmit()">Submit</button>
              </div>
            </div>
          </div>
          <div id="otpPartition" style="display: none">
            <form name="form" (ngSubmit)="otpForm.form.valid" #otpForm="ngForm">
              <div class="">
                <h4>Enter OTP</h4>
                <input type="text" #otp="ngModel" name="otp" id="partitioned" (keypress)="keyPress($event)"
                  minlength="4" maxlength="4" (keydown.space)="$event.preventDefault();" [(ngModel)]="data.otp"
                  pattern="\d*" inputmode="numeric" required>
              </div>
              <div class="form-group mt-3">
                <div *ngIf="otp.invalid && otp.touched" class="error-message">
                  <div *ngIf="otp.errors.required">
                    Please enter OTP
                  </div>
                  <div *ngIf="otp.errors.minlength">
                    Enter 4 digit OTP
                  </div>
                  <div *ngIf="otp.errors.pattern">
                    Invalid OTP
                  </div>
                </div>
              </div>
              <div class="col text-center terms">By clicking Submit, You agree to the <a
                  (click)="termsModalPopup()">Terms and Conditions</a>
              </div>
              <div class="top-gap-lg">
                <button class="btn btn-submit btn-primary" [disabled]="otpForm.form.invalid"
                  (click)="verifyOTPNumber()">Submit</button>
              </div>
            </form>
          </div>
          <div class="col text-center">
            <p class="register-link top-gap-sm" style="cursor: pointer;" routerLink="/login"><a>Already a Member? Login</a></p>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Terms and condition modal -->
  <div class="modal fade" id="termsModal" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body claim-pop text-center">
          <div class="close-modal">
            <button type="button" class="btn close-btn" data-dismiss="modal">x</button>
          </div>
          <div class=SNSection>
            <h4 class=SNHeading>Terms and Conditions:</h4>

            <p class="SNTerms">Please read the following terms and conditions (“T&Cs”) carefully before registering on,
              accessing, downloading or using our application available at https://securenow.app:</p>

            <p class="SNTerms">a. These terms and conditions are meant only for users of SecureNow App.</p>

            <p class="SNTerms">b. By registering on, downloading or using (as applicable) the SecureNow App, you
              automatically and immediately agree to all the T&Cs.</p>

            <p class="SNTerms">c. By accepting the T&Cs or by otherwise using the SecureNow App, you represent that you
              are at least 18 years of age or are an entity legally established and operating under the applicable law
              and have not been previously suspended or removed by SecureNow App, or disqualified for any other reason,
              from availing the Services using the SecureNow App. In addition, you represent and warrant that you have
              the right, authority and capacity to enter into these T&Cs and to abide by all the T&Cs.</p>

            <p class="SNTerms">d. You agree that you will not impersonate any person or entity, or falsely state or
              otherwise misrepresent your identity, age, details or affiliation with any person or entity. In the event
              of any violation of the T&Cs, SecureNow App reserves the right to suspend or permanently prevent you from
              availing Services using the SecureNow App.</p>

            <p class="SNTerms">e. SecureNow App reserves the right to change, modify and add, or remove portions of
              these T&Cs at any time at its sole discretion.</p>
            <p class="SNTerms">f. All materials, trademarks, service marks and trade name contained in the SecureNow App
              are the property of SecureNow and its respective partners. You agree not to sell, license, distribute,
              copy, modify, display, transmit, edit, adapt, create derivative works from, or otherwise make unauthorized
              use of the Materials. SecureNow reserves all rights not expressly granted in these T&Cs.</p>

            <h4 class=SNHeading>Communication Policy:</h4>

            <p class="SNTerms">By accepting the T&Cs, You accept the following:</p>

            <p class="SNTerms">a. SecureNow may send alerts to the mobile phone number/email address provided by you
              while registering with the SecureNow App for the Log-in service or on any updated mobile number/email
              address subsequently provided by you on the SecureNow App. The alerts will be received in case of SMS,
              only if the mobile phone is in ‘On’ mode to receive the SMS, in case of e-mail, only if the e-mail servers
              and e-mail ids are functional. If the mobile phone is in ‘Off’ mode or if the e-mail servers or ids are
              not functional, then you may not get the alert at all or get delayed messages.
            </p>

            <p class="SNTerms">b. SecureNow will make best efforts to provide alerts via SMS/e-mail and it shall be
              deemed that you shall have received the information sent as an alert on the mobile phone number or e-mail
              id provided during the course of, or in relation to, using the SecureNow App or availing any Services.
              SecureNow shall not be under any obligation to confirm the authenticity of the person(s) receiving the
              alert. You cannot hold SecureNow App liable for non-availability of the SMS/email alert services in any
              manner whatsoever.</p>

            <p class="SNTerms">c. The foresaid alert service provided by SecureNow App is an additional facility
              provided for your convenience and that it may be susceptible to error, omission and/or inaccuracy. In the
              event that you observe any error in the information provided in the alert, SecureNow shall be immediately
              informed about the same by you and SecureNow will make best possible efforts to rectify the error as early
              as possible. You shall not hold SecureNow liable for any loss, damages, claim, expense including legal
              cost that may be incurred/suffered by you on account of the SMS/e-mail alert communication through other
              legal permissible service.</p>

            <p class="SNTerms">d. The clarity, readability, accuracy and promptness of providing the SMS/e-mail alert
              service depend on many factors including the infrastructure and connectivity of the service provider.
              SecureNow shall not be responsible for any non-delivery, delayed delivery or distortion of the alert in
              any way whatsoever</p>

            <p class="SNTerms">e. SecureNow App reserves the right to change, modify and add, or remove portions of
              these T&Cs at any time at its sole discretion.</p>

            <p class="SNTerms">f. All materials, trademarks, service marks and trade name contained in the SecureNow App
              are the property of SecureNow and its respective partners. You agree not to sell, license, distribute,
              copy, modify, display, transmit, edit, adapt, create derivative works from, or otherwise make unauthorized
              use of the Materials. SecureNow reserves all rights not expressly granted in these T&Cs.</p>


            <h4 class=SNHeading>Insurance Products Related Policy:</h4>

            <p class="SNTerms">a. Purchase of any insurance product through the SecureNow App is purely voluntary.</p>

            <p class="SNTerms">b. Before you enter into a contract of general insurance, you have a duty under the law
              to disclose every matter that you know or could reasonably be expected to know, that is relevant to the
              insurer’s decision whether to accept the risk of insurance and if so, on what terms.  You have the same
              duty to disclose those matters before you renew, extend, vary or reinstate a contract.</p>

            <p class="SNTerms">c. If you fail to comply with your duty of disclosure, the insurer may be entitled to
              repudiate or reduce its liability under the contract in respect of a claim or may cancel the contract.  If
              your non-disclosure was fraudulent, the insurer may also have the option of voiding the contract from the
              beginning (i.e. treating it as if it never existed).</p>

            <p class="SNTerms">d. Information regarding the full extent of your duty of disclosure is contained in your
              policy wording and should be read carefully at any point in your insurance transaction including when your
              policy is renewed, extended, varied or reinstated.</p>

            <p class="SNTerms">e. Every contract of insurance is subject to the doctrine of utmost good faith, which
              requires that the parties to the contract should act toward each other with the utmost good faith. 
              Failure to do so on your part may prejudice any claim or the continuation of cover provided by Insurers.
            </p>

            <h4 class=SNHeading>DISCLAIMER</h4>

            <p class="SNTerms">The materials provided on the SecureNow App are provided “as is” and without warranties
              of any kind either expressed or implied. SecureNow App is not responsible for the availability of, or the
              content located on or through any external Site. It does not warrant that the functions contained in the
              materials will be uninterrupted or error-free, that defects will be corrected, or that this App and the
              server that makes it available are free of viruses or other harmful components. You (and not SecureNow)
              assume the entire cost of all necessary servicing, or correction.
            </p>

            <p class="SNTerms">SecureNow App will not be responsible or liable for the accuracy, reliability, copyright,
              compliance, legality or decency of any content or any interruption in service. The information and
              descriptions contained herein are not intended to be complete descriptions of all terms, exclusions and
              conditions applicable to the products and services, but are provided solely for general informational
              purposes.</p>

            <p class="SNTerms">This SecureNow App may be linked to other websites which are not maintained by SecureNow
              (“external Sites”). SecureNow App is not responsible for the content of those websites. We encourage you
              to read the privacy policies of these linked sites.</p>

            <h4 class=SNHeading>NO WARRANTIES</h4>

            <p class="SNTerms">SecureNow App makes no representation or warranty whatsoever and assumes no
              responsibility or liability whatsoever in connection with the accuracy, completeness, or currency of the
              materials or the suitability, functionality, or operation of the materials on this or any other site which
              may be hyperlinked to this App. SecureNow App is in no way responsible for the views, content or accuracy
              of any site, which is either hyperlinked to or, from this App , nor does SecureNow App endorse any content
              or products that may be advertised or noted on these sites. Information on this App is subject to change
              at any time without prior notice.</p>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-blue" data-dismiss="modal">Done</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
